import * as React from 'react';
import styled from 'styled-components';
import Svg from '@svg/index';
import { LabelDiv } from '@ui-library/typography';
import { cloneDeep } from 'lodash';
import Input from '@ui-library/input';
import { FixMe } from '@utils/types';
import theme from '@css/theme';
import { Label } from '../typography';
import { Flex } from '../misc';

const Row = styled(Flex)`
  width: 100%;
  justify-content: 'flex-start';
`;

const Column = styled.div`
  flex: 1;
  input {
    width: 100%;
  }
`;
const ButtonText = styled(Label)`
  margin-left: 10px;
  color: ${(props) => props.theme.color.rsPrimary};
`;

interface IDynamicFormProps {
  field: FixMe;
  onChange: FixMe;
  disabled: boolean;
  secret: FixMe;
  hidden?: boolean;
}
interface IDynamicFormState {
  mapping: FixMe;
  count: FixMe;
  initCount: FixMe;
  secret: FixMe;
}

export default class DynamicForm extends React.Component<IDynamicFormProps, IDynamicFormState> {
  constructor(props: IDynamicFormProps) {
    super(props);
    const { keyLeft } = props.field;
    const { keyRight } = props.field;
    this.state = {
      mapping: [
        {
          [keyLeft]: '',
          [keyRight]: '',
        },
      ],
      count: 1,
      initCount: 0,
      secret: [],
    };
  }

  componentDidMount() {
    const { field, onChange, secret } = this.props;
    const secretCopy = cloneDeep(secret || []);
    if (field.default) {
      this.setState(
        {
          mapping: field.default,
          count: field.default.length,
          initCount: field.default.length,
          secret: secretCopy,
        },
        () => onChange(field.value, this.state.mapping),
      );
    }
  }

  public onConfigChange = (index: number, value: string, isLeft: boolean) => {
    const { onChange, field } = this.props;
    const { keyLeft } = field;
    const { keyRight } = field;
    this.setState(
      (prevState: FixMe) => {
        const mapping = prevState.mapping.map((item: FixMe) => ({ ...item }));
        const updatedItem = {
          ...mapping[index],
          [isLeft ? keyLeft : keyRight]: value,
        };
        mapping.splice(index, 1, updatedItem);
        return {
          ...prevState,
          mapping,
        };
      },
      () => onChange(field.value, this.state.mapping),
    );
  };

  public handleDeleteRow = (index: number) => {
    const { onChange, field } = this.props;
    this.setState(
      (prevState: FixMe) => {
        const mapping = prevState.mapping.splice(0);
        const secret = prevState.secret.splice(0);
        mapping.splice(index, 1);
        if (index < secret.length) {
          secret.splice(index, 1);
        }
        const count = prevState.count - 1;
        return {
          ...prevState,
          mapping,
          count,
          secret,
        };
      },
      () => onChange(field.value, this.state.mapping),
    );
  };

  public getPlaceholderValue = (isSecret: boolean, index: number, key: string, secret: FixMe) =>
    isSecret && secret[index] && secret[index][key];

  public restrictiveMode = (index: number, option: string) => {
    const { field } = this.props;
    const { initCount } = this.state;
    const restrictiveMode =
      field.disableInputLeft || field.disableInputRight || field.disableDelete;
    const fieldRestrict = restrictiveMode && index < initCount;
    switch (option) {
      case 'inputLeft':
        return fieldRestrict && field.disableInputLeft;
      case 'inputRight':
        return fieldRestrict && field.disableInputRight;
      case 'delete':
        return fieldRestrict && field.disableDelete;
      case 'any':
        return restrictiveMode;
      default:
        return false;
    }
  };

  public renderSingleRow = (index: number) => {
    const { field, disabled } = this.props;
    const { mapping, secret } = this.state;
    const isSecret = (secret && secret.length > 0) || false;
    const { keyLeft, keyRight, placeholderLeft, placeholderRight } = field;
    return (
      <Row className="m-t-xs m-b-xs" key={index}>
        <Column className="p-r-sm">
          <Input
            value={mapping[index] && mapping[index][keyLeft]}
            placeholder={
              this.getPlaceholderValue(isSecret, index, keyLeft, secret) || placeholderLeft
            }
            onChange={(e: FixMe) => this.onConfigChange(index, e.target.value, true)}
            disabled={disabled || !!this.restrictiveMode(index, 'inputLeft')}
            data-testid="inputLeft"
          />
        </Column>
        <Column className="p-l-sm">
          <Input
            value={mapping[index] && mapping[index][keyRight]}
            placeholder={
              this.getPlaceholderValue(isSecret, index, keyRight, secret) || placeholderRight
            }
            onChange={(e: FixMe) => this.onConfigChange(index, e.target.value, false)}
            disabled={disabled || !!this.restrictiveMode(index, 'inputRight')}
            data-testid="inputRight"
          />
        </Column>
        {mapping.length > 1 && !this.restrictiveMode(index, 'delete') && (
          <Column
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-start',
              alignItems: 'center',
              cursor: 'pointer',
            }}
            className="p-l-sm"
          >
            {!disabled && <Svg name="delete" onClick={() => this.handleDeleteRow(index)} />}
          </Column>
        )}
      </Row>
    );
  };

  handleAddMore = () => {
    this.setState((prevState: IDynamicFormState) => ({
      ...prevState,
      count: prevState.count + 1,
    }));
  };

  public render() {
    const { field, hidden, disabled } = this.props;
    const { count, mapping } = this.state;
    if (hidden) {
      return null;
    }
    return (
      <div data-testid="dynamicForm">
        <Row>
          <LabelDiv className="m-b-xs m-t-lg" data-testid="label">
            {field.label}
          </LabelDiv>
        </Row>
        <Row>
          <Column className="p-r-sm" data-testid="labelLeft">
            {field.labelLeft}
          </Column>
          <Column className="p-l-sm" data-testid="labelRight">
            {field.labelRight}
          </Column>
          {mapping.length > 1 && !this.restrictiveMode(count, 'any') && (
            <Column className="p-l-sm" />
          )}
        </Row>
        {[...Array(count)].map((v: FixMe, index: number) => this.renderSingleRow(index))}
        {!disabled && (
          <a onClick={this.handleAddMore} data-testid="anchor">
            <div className="p-t-sm">
              <Svg name="plus" fill={theme.color.rsPrimary} />
              <ButtonText> ADD MORE</ButtonText>
            </div>
          </a>
        )}
      </div>
    );
  }
}
